

























































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import {QueryMaterials,QuerySysDic} from '../../../api/material'
import {QuerySupplier} from '../../../api/basicDictionary'
import {PurShippingReceipt,QueryPurchaseReceiptDetail} from '../../../api/shipmentsManagement'
@Component
export default class extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    form:any = {
        purchaseReceiptId:this.data.purchaseReceiptId,
        supplierId:this.data.supplierId,
        goodsTypeId:this.data.goodsTypeId,
        receiptNo:Date.now(),
        purShippingReceiptDetailArr:[],
    }
    itemform:object = {
        itemType:null,
        itemId:null,
        itemName:null,
        quantity:null,
        unitId:null,
        batchNo:null,
        expireDate:'',
        isSet:true,
        isNew:true
    }
    tableData:any = [
        {
            id:1,
            itemType:1,
            itemId:2,
            itemName:3,
            quantity:4,
            unitId:5,
            batchNo:6,
            expireDate:'',
            isSet:false,
            isNew:false,
        }
    ]
    sel:any = null

    //按钮状态
    actionStatus = false
    itemOptions:any = []
    goodsTypeOptions:any = []
    supplierOptions:any = []
    itemChange(val){
        let item = this.itemOptions.find((v:any)=>{return v.id==val})
        this.sel.itemName = item.name
        this.sel.itemType = item.type
        this.sel.unitId = item.unitId
    }
    
    addrow() {
        for (let i of this.tableData) {
            if (i.isSet) return this.$message.warning("请先保存当前编辑项");
        }
        let j = Object.assign({},this.itemform)
        this.tableData.push(j);
        this.sel = JSON.parse(JSON.stringify(j));
        this.actionStatus = true
    }
    remove(row,index){
        if(row.isSet){
            this.actionStatus = false
        }
        this.tableData.splice(index, 1);
    }
    //修改
    pwdChange(row, index, cg) {
        //是否是取消操作
        if (!cg) {
            // console.log(this.sel.id)
            // if (!this.sel.id)this.tableData.splice(index, 1);this.actionStatus = false
            this.actionStatus = false
            return row.isSet = !row.isSet;
        }
        //提交数据
        if (row.isSet) {
            console.log(row)
            if(!this.sel.itemId || !this.sel.quantity || !this.sel.batchNo || !this.sel.expireDate){
                this.$message.warning('请填写完整');
                return false
            }
            this.$message.success('保存成功');
            this.sel.isSet = false
            //非新增项标识
            this.sel.isNew = false
            this.$set(this.tableData,index,this.sel)
            console.log(this.tableData)
            this.actionStatus = false
        } else {
            this.sel = JSON.parse(JSON.stringify(row));
            row.isSet = true;
            this.actionStatus = true
        }
    }
    
    created(){
        this.getSelects()
        this.getData()
    }
    //
    async getData(){
        let res = await QueryPurchaseReceiptDetail({PurPurchaseReceiptId:this.data.purPurchaseReceiptId})
        res.data.forEach((item:any) => {
            item.isSet = false
            item.isNew = false
        });
        this.tableData = res.data
    }
    //获取下拉框
    async getSelects(){
        this.itemOptions = (await QueryMaterials({status:true,pageSize:10000,page:1})).data
        this.goodsTypeOptions = (await QuerySysDic({dataType:1,status:true,typeName:''})).data
        this.supplierOptions = (await QuerySupplier({queryString:'',pageSize:10000,page:1})).data.items
    }
    async save(){
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
                let flag = true;
                let findex;
                this.tableData.forEach((item:any,index:any)=>{
                    if(!item.batchNo || !item.expireDate){
                        flag = false
                        findex = index
                        return
                    }
                })
                if(!flag){
                    this.$message.error('请填写批号和有效期')
                    this.sel = JSON.parse(JSON.stringify(this.tableData[findex]));
                    this.tableData[findex].isSet = true;
                    this.actionStatus = true
                    return false
                }
                this.form.purchaseReceiptId = this.data.purPurchaseReceiptId
                this.form.purShippingReceiptDetailArr = this.tableData
                let res = await PurShippingReceipt(this.form)
                if(res.code==2000){
                    this.$emit('save-success')
                    this.$emit('input',false);
                }
            }
        })
    }
    cancel(){
        (this.$refs.form as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    formRule={
        supplierId:[{required: true,message:'不能为空',trigger: 'blur'}],
        goodsTypeId:[{required:true,message:'不能为空',trigger: 'blur'}],
        receiptNo:[{required:true,message:'不能为空',trigger: 'blur'}],
    }
}
